import { Injectable} from '@angular/core';
import { BadgeCountResults } from '../models/push/badge-count-results';
import { MyfileApiService } from './myfile-api.service';
import { Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BadgeCountService {

  badgeCountUpdated$ = new Subject<BadgeCountResults>();

  constructor(
    private myfileApiService: MyfileApiService
  ) {
  }

  getBadgeCount() {
    return this.myfileApiService.getBadgeCounts().subscribe((result: BadgeCountResults | undefined) => {
      if (result) {
        this.badgeCountUpdated$.next(result);
      }
    });
  }
}